import { HttpMethod } from '@inpart-io/devtools';
import { type Query } from '@inpart-io/devtools-iap';
import { REMOVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type ITriggeringEvents, type ITriggeringEventStatusPayload, triggeringEventsManager } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

export const UPDATE_TRIGGERING_EVENTS_STATUS = 'onUpdateTriggeringEventStatus';
export const RETRIEVE_BY_QUERY_WITH_COUNT = 'RETRIEVE_BY_QUERY_WITH_COUNT';
export const DISCARD_DATA_OBJECT = 'discardDataObject';

export interface IResponseWithCount {
    idList: number[];
    total: number;
}

export const actions: ActionTree<ITriggeringEvents, unknown> = {
    async [RETRIEVE_BY_QUERY_WITH_COUNT](context, { query = {}, properties }: { properties?: string; query?: Query }): Promise<IResponseWithCount> {
        const response = await triggeringEventsManager.searchWithCount(query, { properties }, HttpMethod.POST);

        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: response.content });
        const idList = response.content.map((dataObject) => {
            return dataObject.dobjId;
        });
        return { idList, total: response.total };
    },

    async [UPDATE_TRIGGERING_EVENTS_STATUS](
        context,
        {
            triggeringEventId,
            status,
            payload,
            properties
        }: { triggeringEventId: number; status: string; payload: ITriggeringEventStatusPayload; properties?: string }
    ): Promise<ITriggeringEvents> {
        const result = await triggeringEventsManager.onUpdateTriggeringEventStatus(triggeringEventId, status, payload, { properties });
        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
        return result;
    },

    [DISCARD_DATA_OBJECT](context, { dobjId }: { dobjId: number }): void {
        context.commit(REMOVE_DATA_OBJECTS, { dobjId });
    }
};
